import React, { useLayoutEffect } from 'react';

function usePagination(total, current) {
  const delta = 2;
  const left = current - delta;
  const right = current + delta + 1;

  let range = [];
  let rangeWithEllipses = [];
  let l;

  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= left && i < right)) {
      range.push(i);
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithEllipses.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithEllipses.push('...');
      }
    }
    rangeWithEllipses.push(i);
    l = i;
  }

  return rangeWithEllipses;
}

export default usePagination;
